module.exports = __webpack_public_path__ + "media/images/concert-75088b5b9389afc470918f976a136135.png";